import {
  InventoryTagSortOption,
  InventoryTagStatus,
  TagType,
} from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useInventoryTagsQuery = createQueryHook(
  'inventory.inventoryTags',
  (params: {
    searchTerm?: string;
    tagNumbers?: string[];
    tagTypes?: TagType[];
    statuses?: InventoryTagStatus[];
    itemIds?: string[];
    facilityIds?: string[];
    isRevised?: boolean;
    sorting?: InventoryTagSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    inventoryTags: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          tagNumbers: params.tagNumbers,
          tagTypes: params.tagTypes,
          statuses: params.statuses,
          itemIds: params.itemIds,
          facilityIds: params.facilityIds,
          isRevised: params.isRevised,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      page: {
        total: true,
        offset: true,
        limit: true,
      },
      entries: {
        id: true,
        tagNumber: true,
        tagType: true,
        generatedAt: true,
        status: true,
        grossQuantity: true,
        tare: true,
        netQuantity: true,
        item: {
          id: true,
          name: true,
          skuNumber: true,
        },
        isRevised: true,
        quantityCaptureMethod: true,
        tareCaptureMethod: true,
        customAttributes: true,
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.inventoryTags.entries.map((tag) => ({
        id: tag.id,
        name: tag.tagNumber,
      })) ?? [],
  },
);
